export { templateFactory as createTemplateFactory } from '../../@glimmer/opcode-compiler/index.js';
